export default __webpack_public_path__ + "static/media/twitter.c66e5d59.svg";